import { Theme } from '@material-ui/core';
import { createContext } from 'react';
import { type ClientConfig } from '../clientConfig/types';

export const ClientConfigContext = createContext<ClientConfig>({
    aiaInstanceMapping: {},
    bypassProve: false,
    customerSupportNumber: '',
    brandConfig: {
        acceptedEhrSystems: [],
        backgroundColor: '',
        backgroundImage: '',
        brand: '',
        crossRegionEnabled: false,
        cssbranding: '',
        default: false,
        email: {
            emailFooterImage: '',
            fromAddress: '',
            imageDimensions: {
                height: '',
                width: '',
            },
            mobileApps: {},
            senderName: '',
            privacyPolicy: '',
        },
        identityVerification: {
            theme: '',
            clear: {
                enabled: false,
                jwtAudienceList: [],
            },
            ui: {
                header: { en: '', es: '' },
                list: [],
                buttons: [],
            },
        },
        links: {
            faq: '',
            privacyPolicy: '',
            termsAndConditions: '',
            nonDiscrimination: '',
        },
        logo: {
            altText: '',
            uri: '',
            size: '',
        },
        name: '',
        promotion: {
            apps: [],
            appImage: '',
            appStoreImage: '',
            appStoreRedirectLink: '',
            banner: {
                logoFilename: '',
                subText: '',
            },
            brandColor: '',
            enabled: false,
            logoImagePath: '',
            platformStoreRedirectLink: '',
            playStoreImage: '',
            playStoreRedirectLink: '',
            qrCodeImage: '',
        },
        signInPolicy: '',
        theme: '',
        userAgents: [],
    },
    ehrPrefix: '',
    i18nPath: '',
    identityVerification: {
        clear: {
            requiredSdkVersion: '',
            whiteLogoIconUri: '',
            blackLogoIconUri: '',
            sessionsUrl: '',
            verifyUrl: '',
        },
        ui: {
            buttons: [],
            header: {
                en: '',
                es: '',
            },
            list: [],
        },
    },
    pimsApiUrl: '',
    redirectAllowedList: [],
    myChartConfig: {
        prefix: '',
        domains: {},
        redirectBaseUrls: [],
    },
    tier: '',
    b2cTenantConfig: {
        tenantName: '',
        tenantId: '',
        signInPolicies: {},
        clientId: '',
        scopes: [],
        redirectUri: '',
        postLogoutRedirectUri: '',
    },
    cdnPath: '',
    userActivityLimitMs: 900000,
    mfaConfig: {
        checkMarkIconUri: '',
        securityIconUri: '',
        showResendButtonInMilliSecond: 1000,
        verificationCodeExpireTimeInSeconds: 1,
        mfaEnabled: true,
    },
    amplitudeConfig: {
        apiKey: '',
        apiKeyAuthUrl: '',
        authUrl: '',
        noAuthUrl: '',
        enableEvents: true,
    },
    appPromotion: {
        brands: [],
        devices: [],
        enable: false,
        mode: 'banner',
    },
    theme: {
        palette: {},
    } as Theme,
    version: '',
});
